import { useContext } from 'react';
import UserContext from './UserProvider/UserContext.js';

function useUserContext() {
  return useContext(UserContext);
}

export default useUserContext;
